export default __webpack_public_path__ + "static/media/gold-medal.66846fc8.svg";